module.exports = __webpack_public_path__ + "static/img/01038B_1_R_20200812_fit.3827c42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_1_R_20200812_fit.png
// module id = r174
// module chunks = 0